import React from "react";
import "./utils.css";
import { Btn, SelectInput } from "./utils";
import { SearchNormal } from "iconsax-react";

const SearchComp = ({sortBy, priceRange, location, property, handleLocChange, handlePriceChange, handlePropertyChange,handleSortChange, options, optionsPrice, optionsLoc, optionsType, btnClick, widthStyle}) => {

  return (
    <div className="search" style={{width: widthStyle}}>
      {sortBy && <div className="sort-by search-div">
        <p>Sort by</p>
        <SelectInput options={options} onChange={handleSortChange} />
      </div>}
      {priceRange && <div className="price-range search-div">
        <p>Price Range</p>
        <SelectInput options={optionsPrice} onChange={handlePriceChange} />
      </div>}
      {property && <div className="location search-div">
        <p>Property Type</p>
        <SelectInput options={optionsType} onChange={handlePropertyChange} />
      </div>}
      {location && <div className="location search-div">
        <p>Location</p>
        <SelectInput options={optionsLoc} onChange={handleLocChange} />
      </div>}
      <div className="search-btn">
        <Btn btnClass={"home-btn"} btnClick={btnClick} btnText={"Search"} leftIcon={<SearchNormal size={24} color="#EEF0FB" />} />
      </div>
    </div>
  );
};

export default SearchComp;
